<template>
  <span v-text="text" :class="['badge-bd', {'badge-dot': typeof text === 'undefined', 'badge-single': typeof text !== 'undefined' && text.toString().length === 1}]"></span>
</template>
<script>
/**
   * @param text [String, Number] 显示的数量
   * @describe 默认显示小红点,想要不显示则可用v-if隐藏组件
   *
   * @example
   *
    <t-badge text='12'></t-badge>
   */

export default {
  name: 'tBadge',
  props: {
    text: [String, Number],
  },
};

</script>
<style lang="scss">
.badge-bd {
  display: inline-block;
  text-align: center;
  background: red;
  color: #fff;
  font-size: 0.12rem;
  height: 0.16rem;
  line-height: 0.16rem;
  border-radius: 0.08rem;
  padding: 0 0.06rem;
  background-clip: padding-box;
  vertical-align: middle;
}

.badge-single {
  padding: 0;
  width: 0.16rem;
}

.badge-dot {
  height: auto;
  padding: 0.05rem;
}

</style>



// WEBPACK FOOTER //
// src/components/badge.vue